import logoPrimary from '@assets/images/common/brand/logo-primary.svg';
import { COMPANY_URL } from '@src/routes/company';
import Button from '@src/ui/elements/button/Button';

function BizsolIntroduction() {
  const appName = import.meta.env.VITE_APP_NAME || 'DXSTAR';
  return (
    <div className='flex flex-col gap-8'>
      <div className='grid place-items-center'>
        <img
          alt={import.meta.env.VITE_APP_NAME}
          className='h-auto max-h-[72px] w-[400px] object-contain'
          src={logoPrimary}
        />
        <div className='mt-10 text-sm font-medium'>{appName}アカウントをお持ちの方</div>
        <div className='mt-4 w-full text-left text-[10px]'>
          ログインすると{appName}
          の既存アカウントと連携され、2回目以降はログインID/パスワードの入力不要でログインすることが出来ます。
        </div>
        <div className='mt-6 w-full max-w-[400px] text-center'>
          <Button
            href={COMPANY_URL.LOGIN}
            size='m'
            variant='primary'
            fullWidth
            fullRounded
          >
            ログイン
          </Button>
        </div>
        <div className='mt-8 h-px w-full bg-gray-200 md:mt-5'></div>
        <div className='mt-8 text-sm font-medium md:mt-6'>{appName}アカウントをお持ちでない方</div>
        <div className='mt-4 w-full text-left text-[10px]'>
          アカウントを連携した状態で{appName}に新規会員登録できます。
        </div>
        <div className='mt-6 w-full max-w-[400px] text-center'>
          <Button
            href={COMPANY_URL.REGISTRATION}
            size='m'
            variant='primary'
            fullWidth
            fullRounded
          >
            新規会員登録
          </Button>
        </div>
      </div>
    </div>
  );
}

export default BizsolIntroduction;
